import React from 'react';
import type { PlanCardsProps } from '../../types';
import PlanCard from '../../shared/PlanCard';
import { PlanCardWrapper } from './index.styles';
import { flexProducts, normalizeProductFamily } from '../../../../constants/products';

const PlanCards: React.FC<PlanCardsProps> = ({ orderedPlans }) => (
  <>
    {orderedPlans.map((plan, index) => (
      <PlanCardWrapper key={plan.id} $gridColumn={index + 2}>
        <PlanCard
          plan={plan}
          isCurrent={plan.isCurrent}
          price={plan.family === normalizeProductFamily(flexProducts.free) ? null : plan.priceSummary}
        />
      </PlanCardWrapper>
    ))}
  </>
);

export default PlanCards;
